import { Dialog, DialogContent } from "@mui/material";
import ViewReverse from "./ViewReverse";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import Text from "./Text";
import OTPField from "./OtpField";
import Button from "./Button";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import {
  generateGeneralOtp,
  verifyGeneralOtp,
} from "../store/actions/common-action";
import { useState } from "react";
import ErrorText from "./ErrorText";
import { cn, getContentKeyAccToLang } from "../utils/utils";
import dynamicfunction from "../utils/dynamicfunction";
import Timer from "./Timer";
import ViewItems from "./ViewItems";
import { fontSizes } from "../constants/constants";

const OtpModal = ({ open, onClose, onVerify, type }) => {
  const dispatch = useDispatch();
  const { isArabic } = dynamicfunction();

  const { common_loading } = useSelector((state) => state.common);
  const { fundsContent } = useSelector((state) => state.content);

  const [otp, setOtp] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_subscribe?.data?.attributes,
      key,
      isArabic
    );
  };

  const resendOtp = () => dispatch(generateGeneralOtp(type));

  const verifyOtp = (otpCode) => {
    const apiData = {
      otpCode: otpCode ?? otp,
    };

    dispatch(
      verifyGeneralOtp(
        apiData,
        () => {
          setErrorMessage(null);
          onClose();
          onVerify && onVerify();
        },
        (error) => setErrorMessage(error?.message)
      )
    );
  };

  return (
    <Dialog open={open} maxWidth={"lg"}>
      <DialogContent className="sm:min-w-[22rem]">
        <ViewReverse
          className={"gap-2 items-center cursor-pointer"}
          onClick={() => {
            setErrorMessage(null);
            onClose();
          }}
        >
          <ReactSVG src={icons.rightAngle} className={isArabic ? "" : "rotate-180"} />
          <Text text={getContentKey("back")} color="text-dark-grey" />
        </ViewReverse>
        <Text
          text={getContentKey("enter_otp_code")}
          className={"my-3"}
          color="text-dark-grey"
          isCenter
        />

        <OTPField
          separator={<span>-</span>}
          otpChange={(otp) => {
            setOtp(otp);
            otp?.length == 4 &&
              setTimeout(() => {
                verifyOtp(otp);
              }, 500);
          }}
        />

        <ErrorText text={errorMessage ?? null} isCenter />

        <div className={cn('flex my-3', isArabic ? "justify-start" : "justify-end")}>
          <Timer duration={60} onComplete={() => setIsResendDisabled(false)} />
        </div>

        {common_loading ? (
          <div className="w-full">
            <Loader height={"h-9"} width={"w-9"} />
          </div>
        ) : (
          <ViewReverse className={"gap-4"}>
            <Button
              text={getContentKey("resend_code")}
              bgColor="bg-white"
              color={"text-primary"}
              className={`text-center w-36 px-0 border ${!isResendDisabled && 'border-primary'}`}
              onClick={resendOtp}
              isDisabled={isResendDisabled}
            />
            <Button
              text={getContentKey("confirm_code")}
              bgColor="bg-primary"
              className={"text-center w-36 px-4"}
              onClick={verifyOtp}
              isDisabled={!(otp?.length > 3)}
            />
          </ViewReverse>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OtpModal;
